module.exports = __webpack_public_path__ + "static/media/24UHCHR14.97ec9573.jpg";